import { baseApi } from './baseApi';

export const backupApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getBackups: builder.query({
      query: () => '/backups',
      providesTags: ['Backup'],
    }),
    createBackup: builder.mutation({
      query: () => ({
        url: '/backups',
        method: 'POST',
      }),
      invalidatesTags: ['Backup'],
    }),
    deleteBackup: builder.mutation({
      query: (filename) => ({
        url: `/backups/${filename}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Backup'],
    }),
  }),
});

export const {
  useGetBackupsQuery,
  useCreateBackupMutation,
  useDeleteBackupMutation,
} = backupApi;
